import api from "../utils/axios";

export async function getWishlist() {
  try {
    const res = await api.get(`/auth/favorites`);
    return res.data.products;
  } catch (error) {
    console.error("Wishlist fetch error:", error);
    throw error;
  }
}

export async function addWishlist(item) {
  console.log("Items addWishlist:", item);
  const response = await api.fetch(`/auth/wishlists`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });

  return response.json();
}

export async function removeWishlist(id) {
  const response = await api.fetch(`/auth/wishlists/${id}`, {
    method: "DELETE",
  });

  return response.ok;
}
